import { useContext, useMemo } from 'react'
import { EshopContext } from '../components/EshopProvider'
import { Currency } from '@/utils/currency'
import { ccToString, languageToLanguageId } from '@/eshop/constants'

interface K2Setup {
    languageId: number
    currencyCode: Currency
    currency: string
}

export function useK2Setup() {
    const { lang, currency } = useContext(EshopContext)

    return useMemo(
        (): K2Setup => ({
            languageId: languageToLanguageId[lang] || 5,
            currencyCode: currency,
            currency: ccToString[currency],
        }),
        [lang, currency]
    )
}
